module.exports = __webpack_public_path__ + "static/media/thirdFloorFront.c145cc36.png";